import {useWindowDimensions} from 'react-native';
import {useMemo} from 'react';
import {mergeDeepRight} from 'ramda';

type ResponsiveStyles<T> = {
  [breakpoint: number]: Partial<T>;
};
// {
//   720: {
//     indicator: {
//       backgroundColor: 'orange',
//       width: 33,
//     }
//   },
//   640: {
//     indicator: {
//       backgroundColor: 'yellow',
//     }
//   },
// }

export function useResponsiveStyles<T extends object>(
  baseStyles: T,
  responsiveOverrides: ResponsiveStyles<T>,
): T {
  const {width} = useWindowDimensions();
  const responsiveStyles = useMemo(() => {
    let reducedStyle: Partial<T> = Object();
    const breakPoints = Object.keys(responsiveOverrides).sort(
      (a: any, b: any) => b - a,
    );
    // replaced with for loop for optimizations
    for (const bp of breakPoints) {
      const breakpoint = Number(bp);
      if (width < breakpoint) {
        // keep adding override styles into our reduced styles
        reducedStyle = mergeDeepRight(
          reducedStyle,
          responsiveOverrides[breakpoint],
        );
      }
    }

    // Merge styles

    return mergeDeepRight(baseStyles, reducedStyle) as unknown as T;
  }, [width, baseStyles, responsiveOverrides]);

  return responsiveStyles;
}
